export enum TableKey {
  AbrdnSettingsActivityLevels = 'abrdn-settings.activity-levels',
  AbrdnSettingsOrderReasons = 'abrdn-settings.order-reasons',
  HomeAbrdnAllTrades = 'home.abrdn.all-trades',
  FundsFunds = 'funds.funds',
  FundHoldings = 'fund.holdings',
  OrderFunds = 'order.funds',
  CasesOpenAbrdnOrders = 'cases.open.abrdn-orders',
  OrderTrades = 'order.trades',
  FundPastTrades = 'fund.past-trades',
  AppSettingsHifcaHidta = 'app-settings.hifca-hidta',
  AppSettingsHifcaHidtaCountyZips = 'app-settings.hifca-hidta-county-zips',
  AppSettingsPepScreeningLists = 'app-settings.pep-screening-lists',
  AppSettingsSanctionsScreeningLists = 'app-settings.sanctions-screening-lists',
  AppSettingsWatchlistScreeningLists = 'app-settings.watchlist-screening-lists',
  AuditTrail = 'audit-trail',
  CasesClosedCustomerCases = 'cases.closed.customer-cases',
  CasesClosedEllipticCases = 'cases.closed.elliptic-cases',
  CasesOpenCustomerCases = 'cases.open.customer-cases',
  CasesOpenEllipticCases = 'cases.open.elliptic-cases',
  CasesTransactionClosed = 'cases.transaction.closed',
  CasesTransactionOpen = 'cases.transaction.open',
  CasesTravelRuleClosed = 'cases.travel-rule.closed',
  CasesTravelRuleOpen = 'cases.travel-rule.open',
  CustomerCurrentCases = 'customer.current-cases',
  CustomerFormerCases = 'customer.former-cases',
  CustomersCustomers = 'customers.customers',
  CustomerTransactions = 'customer.transactions',
  HomeAssignedCustomerCases = 'home.assigned.customer-cases',
  HomeAssignedEllipticCases = 'home.assigned.elliptic-cases',
  HomeAssignedTransactionCases = 'home.assigned.transaction-cases',
  HomeAssignedTravelRuleCases = 'home.assigned.travel-rule-cases',
  LeadershipAssigneePerformance = 'leadership.assignee-performance',
  RetailRisksActingOwnAccount = 'retail-risks.acting-own-account',
  RetailRisksCountryOfBirth = 'retail-risks.country-of-birth',
  RetailRisksCountryOfCitizenship = 'retail-risks.country-of-citizenship',
  RetailRisksCountryOfResidence = 'retail-risks.country-of-residence',
  RetailRisksExpectedAnnualInvestment = 'retail-risks.expected-annual-investment',
  RetailRisksOccupation = 'retail-risks.occupation',
  RetailRisksPurposeOfAccount = 'retail-risks.purpose-of-account',
  RetailRisksSourceOfFunds = 'retail-risks.source-of-funds',
  Rules = 'rules',
  SAR = 'sar',
  SenderRecipientCases = 'transaction-case.sender-recipient-cases',
  TransactionCaseSenderRecipientTransactions = 'transaction-case.sender-recipient-transactions',
  UploadedData = 'uploaded-data',
  UsersActive = 'users.active',
  UsersAll = 'users.all',
  UsersInactive = 'users.inactive'
}
